import { Module } from 'vuex';
import { RootState } from '@/store/index';
import state from './state';
import getters from './getters';
import actions from './actions';
import mutations from './mutations';

import type { TChatStoreState } from './state';

export { TChatStoreState };

const store: Module<TChatStoreState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default store;
